import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import Dashboard from "./Class-ix/dashboard/Dashboard";
import StudentInformation from "./Class-ix/studentinfo/StudentInformation";
import Login from "./Class-ix/Login/Login";
import Payment from "./Class-ix/payment/Payment";
import PaymentResponse from "./Class-ix/payment/PaymentResponse";
import Adminlogin from "./Admin/Pages/Adminlogin";
import Admindashboard from "./Admin/Pages/Admindashboard";
import Classxnotice from "./Admin/Pages/Classxnotice";

function App() {
  const [environment, setEnvironment] = useState("YES");

  useEffect(() => {
    // ── 1. Disable Right Click ─────────────────────────────────
    const disableRightClick = (e) => e.preventDefault();
    document.addEventListener("contextmenu", disableRightClick);

    // ── 2. Disable F12, Ctrl+Shift+I/J/C, Ctrl+U ──────────────
    const disableKeys = (e) => {
      // F12
      if (e.key === "F12") {
        e.preventDefault();
        return;
      }
      // Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+Shift+C
      if (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key.toUpperCase())) {
        e.preventDefault();
        return;
      }
      // Ctrl+U (View Source)
      if (e.ctrlKey && e.key.toLowerCase() === "u") {
        e.preventDefault();
        return;
      }
      // Ctrl+S (Save Page)
      if (e.ctrlKey && e.key.toLowerCase() === "s") {
        e.preventDefault();
        return;
      }
      // Ctrl+P (Print - can expose source)
      if (e.ctrlKey && e.key.toLowerCase() === "p") {
        e.preventDefault();
        return;
      }
    };
    document.addEventListener("keydown", disableKeys);

    // ── 3. Detect DevTools Open by window size difference ──────
    const devToolsDetect = setInterval(() => {
      const threshold = 160;
      const widthDiff = window.outerWidth - window.innerWidth > threshold;
      const heightDiff = window.outerHeight - window.innerHeight > threshold;
      if (widthDiff || heightDiff) {
        document.body.innerHTML =
          "<div style='display:flex;justify-content:center;align-items:center;height:100vh;background:#fff;'>" +
          "<h2 style='color:red;font-family:Arial;text-align:center;'>⚠️ Access Denied.<br/>Developer Tools are not allowed.</h2>" +
          "</div>";
      }
    }, 1000);

    // ── 4. Debugger Trap — freezes DevTools when open ──────────
    const debuggerTrap = setInterval(() => {
      (function () {
        // eslint-disable-next-line no-debugger
        debugger;
      })();
    }, 100);

    // ── 5. Console warning message ─────────────────────────────
    console.log = () => {};
    console.warn = () => {};
    console.error = () => {};
    console.info = () => {};
    console.debug = () => {};

    // ── Cleanup on unmount ─────────────────────────────────────
    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("keydown", disableKeys);
      clearInterval(devToolsDetect);
      clearInterval(debuggerTrap);
    };
  }, []);

  return (
    <Router>
      <Routes>
        {/* Default route → Login */}
        <Route path="/" element={<Login />} />

        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/student-info" element={<StudentInformation />} />

        <Route
          path="/student-payment"
          element={
            <Payment
              setEnvironment={setEnvironment}
              environment={environment}
            />
          }
        />

        <Route path="/admin-login" element={<Adminlogin />} />
        <Route path="/admin-dashboard" element={<Admindashboard />} />
        <Route path="/admin-class-x" element={<Classxnotice />} />

        <Route
          path="/payment-response"
          element={
            <PaymentResponse
              setEnvironment={setEnvironment}
              environment={environment}
            />
          }
        />
      </Routes>
    </Router>
  );
}

export default App;